import React, { useState } from "react";
import * as S from "../css/ChangePassword.styles";
import { useEditPassword } from "../api/useEditPassword";
import Swal from "sweetalert2";

function ChangePassword() {  
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmed, setConfirmed] = useState("");

  const { mutate: changePassword } = useEditPassword(oldPassword, password);

  const handleOldPassword = (e) => {
    setOldPassword(e.target.value);
  };
  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmedPassword = (e) => {
    setConfirmed(e.target.value);
  };

  const handleChangePassword = () => {
    if (password === "" || confirmed === "" || oldPassword === "") {
      Swal.fire({
        icon: "warning",
        title: "비밀번호를 입력해주세요!",
        confirmButtonText: "확인",
      });

      return;
    }

    if (password !== confirmed) {
      Swal.fire({
        icon: "warning",
        title: "비밀번호가 일치하지 않습니다!",
        text: "변경할 비밀번호와 비밀번호확인이 동일한지 확인해주세요.",
        confirmButtonText: "확인",
      });

      return;
    }

    Swal.fire({
      title: "비밀번호를 변경하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "변경",
      cancelButtonText: "취소",
      icon: "question",
    }).then((result) => {
      if (result.isConfirmed) {
        changePassword();
      }
    });
  };
  
  const handleKeyDownEnter = (e) => {
    if (e.key === "Enter") {
      handleChangePassword();
    }
  };

  return (
    <S.PasswordContainer onKeyDown={handleKeyDownEnter}>
      <h4>비밀번호 변경하기</h4>
      <br />
      <p>현재 비밀번호와 동일하지 않게 설정해주세요!</p>
      <p>회원정보와 연관성이 없는 비밀번호를 설정해주세요!</p>
      <p>연속되거나 동일, 반복된 숫자가 없는 비밀번호를 설정해주세요!</p>
      <p>여러 사이트에서 사용하지 않는 비밀번호를 설정해주세요!</p>
      <br />
      <span>
        현재 비밀번호 :
        <input type="password" placeholder="비밀번호를 입력해주세요." onChange={handleOldPassword} />
      </span>
      <span>
        변경할 비밀번호 :
        <input type="password" placeholder="비밀번호를 입력해주세요." onChange={handlePassword} />
      </span>
      <span>
        비밀번호 확인 :
        <input type="password" placeholder="비밀번호를 입력해주세요." onChange={handleConfirmedPassword} />
      </span>
      <button style={{left: 0}} onClick={handleChangePassword}>변경</button>
    </S.PasswordContainer>
  );
}

export default ChangePassword;
